export default __webpack_public_path__ + "static/media/barrier.13b2506e.png";